<template>
    <div class="control control-date">
        <div class="control-label" v-if="label">{{label}}</div>
        <div v-if="readOnly" class="read-only">{{formattedDate ? formattedDate : "No date"}}</div>
        <date-picker v-else v-model="dateValue" :placeholder="placeholder" :input-class="'form-control' + (showErrorState ? ' is-datepicker-invalid is-invalid' : '')"
                     :minute-step="5" :show-second="false" format="DD/MM/YYYY" @input="onInput"></date-picker>
        <div v-if="required && isEmpty" class="error">The field {{label}} is required.</div>
        <div v-if="errors">
            <div :key="index" v-for="(error, index) in errors" class="error">{{error !== true ? error : ''}}</div>
        </div>
    </div>
</template>

<script>
    import dates from '../tools/dates';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import { DateTime } from 'luxon';

    export default {
        name: 'control-date',
        props: ['label', 'value', 'placeholder', 'hasErrors', 'state', 'readOnly', 'errors', 'required'],
        components: { DatePicker },
        data() {
            return {
                dateValue: null,
            };
        },
        created() {
            this.dateValue = (this.value ? (this.value instanceof DateTime ? this.value.toJSDate() : this.value) : null);
        },
        computed: {
            formattedDate() {
                return dates.formatDate(this.dateValue);
            },
            isEmpty() {
                return (this.dateValue === null || this.dateValue === undefined);
            },
            showErrorState() {
                return (this.errors || this.hasErrors || (this.required && this.isEmpty));
            },
        },
        watch: {
            value(newValue) {
                this.dateValue = (newValue ? (newValue instanceof DateTime ? newValue.toJSDate() : newValue) : null);
            }
        },
        methods: {
            onInput(newValue) {
                this.$emit('input', dates.getDateTime(newValue));
            },
        }
    };
</script>

<style>
    .control-date input {
        cursor: pointer;
    }

    .control-date div.read-only {
        margin: 0.2rem 0;
        border-radius: 0.25rem;
        border: 1px solid grey;
        padding: 0.3rem 0.5rem;
        background-color: rgba(255, 255, 255, 0.4);
        flex: 1 1 auto;
        font-size: 0.9rem;
    }

    .control-date .el-date-editor.el-input {
        width: 100%;
    }
    /*    .is-datepicker-invalid input {
        border-color: #dc3545;
    }*/

    input.is-datepicker-invalid.is-invalid {
        background-position: right 1.7rem center;
        padding-right: 2.5rem;
    }

    .control-date .vdatetime {
        position: relative;
    }

    .control-date .clear-icon {
        position: absolute;
        top: 0.6rem;
        right: 0.4rem;
        cursor: pointer;
        color: lightgray;
    }

        .control-date .clear-icon:hover {
            color: gray;
        }
</style>
